<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>

<div class="vifs">     
    <v-data-table
    :headers="headers"
    :items="vifs"
    :search="search"
    sort-by="id"
    class="elevation-1"
    @dblclick:row="on_dbl_click"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title><h2 class="br">Virtual Interfaces - VIF</h2></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ props }">
            <v-btn @click="new_item(item)"
              color="primary" dark class="mb-2"
              v-bind="props"
            >
              New VIF
            </v-btn>
          </template>
          <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
            <v-card-title>
              <span class="headline">{{ form_title }}</span>
            </v-card-title>

            <v-card-text>
              <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                  <v-col cols="12">
                    <div v-if="edited_index != -1">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.id"
                        label="ID"
                      ></v-text-field>
                    </div>

                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.name"
                        label="Name"
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.port"
                        label="Port"
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-combobox
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.encapsulation"
                        label="Encapsulation"
                        :items="['Untagged', 'Dot1Q', 'QinQ']"
                      ></v-combobox>                    
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider rules="svid" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.svid"
                        label="SVID. Service VLAN Id (Outer VLAN Id)."
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider rules="cvid" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.cvid"
                        label="CVID. Client VLAN Id (Inner VLAN Id)."
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <v-text-field
                      v-if="edited_index != -1"
                      v-bind:readonly="edited_index != -1"
                      v-model="edited_item.mac"
                      label="MAC"
                    ></v-text-field>

                    <div>Flags</div>
                    <treeselect
                      v-model="edited_item.flags"
                      :multiple="true" 
                      :options="flags"
                    />

                    <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.mtu"
                        label="MTU"
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" :disabled="invalid" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-form></v-card></ValidationObserver>
        </v-dialog>
      </v-toolbar>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="me-2"
        @click="edit_item(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="delete_item(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
    </template>
    </v-data-table>
</div>
</template>
  
<script>
  import api_client from '../services/api.js';
  import Treeselect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { ValidationProvider, extend } from 'vee-validate';
  import { ValidationObserver } from 'vee-validate';
  import { required, numeric } from 'vee-validate/dist/rules';
  import "../validation_rules.js";

  extend('cvid', {
    message: 'Incorrect CVID value',
    validate: value => (value >= 0 || value === '*' || value === '')
  });

  extend('svid', {
    message: 'Incorrect SVID value',
    validate: value => (value >= 0 || value === '')
  });

  export default {
    name: "vif",
    components: { Treeselect, ValidationProvider, ValidationObserver },
    data: () => ({
        search: '',
        dialog: false,
        headers: [
            { text: 'Id', value: 'id', align: 'start' },
            { text: 'Name', value: 'name' },
            { text: 'Port', value: 'port' },
            { text: 'SVID', value: 'svid' },
            { text: 'CVID', value: 'cvid' },
            { text: 'Encapsulation', value: 'encapsulation' },
            { text: 'MAC', value: 'mac' },
            { text: 'Flags', value: 'flags' },
            { text: 'MTU', value: 'mtu' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        flags: [
          {
            id: 'proxy_arp',
            label: 'Proxy ARP',
          },
          {
            id: 'kni',
            label: 'KNI',
          },
          {
            id: 'l3_subs',
            label: 'L3 subscribers',
          },
          {
            id: 'l2_subs',
            label: 'L2 subscribers',
          },
          {
            id: 'npf_on',
            label: 'NPF',
          },
          {
            id: 'flow_acct',
            label: 'Flow Accounting',
          },
          {
            id: 'pppoe_on',
            label: 'PPPoE',
          },
          {
            id: 'rpf',
            label: 'Reverse Path Filter',
          },
          {
            id: 'dhcp_rel',
            label: 'DHCP Relay',
          },
          {
            id: 'NAT',
            label: 'NAT',
          }
        ],
        vifs: [],
        edited_index: -1,
        edited_item: {
        },
        default_item: {
            id: 0,
            name: '',
            port: '',
            svid: '',
            cvid: '',
            encapsulation: 'Dot1Q',
            mac: '',
            flags: [],
            mtu: 1500,
        },
        old_flags: [],
        save_steps:[],
        save_step_ind: -1,
    }),

    computed: {
        form_title() {
            return this.edited_index === -1 ? 'New VIF' : 'VIF';
        },
    },

    created() {
      this.initialize();
    },

    methods: {
        initialize() {
          api_client.sh_vifs()
          .then(response => {
              this.vifs = response.data
          })
          .catch(error => {
              console.log(error);
          })
        },

        edit_item(item) {
            this.edited_index = this.vifs.indexOf(item);
            this.edited_item = Object.assign({}, item);
            this.old_flags = Object.assign([], item.flags);
            this.dialog = true;
        },

        new_item() {
            requestAnimationFrame(() => {
              this.$refs.observer.reset();
            });          
            this.edited_index = -1;
            this.edited_item = Object.assign({}, this.default_item);
            this.dialog = true;
        },

        on_dbl_click(event, data) {
		        this.edit_item(data.item);
        },

        close() {
            this.dialog = false;
        },

        delete_item(item) {
          this.edited_index = this.vifs.indexOf(item);
          this.edited_item = Object.assign({}, item);
          this.$confirm("Are you sure you want to delete VIF '" + item.name + "' ?")
          .then(() => {
            this.delete_item_confirm();
          });
        },

        delete_item_confirm() {
          api_client.del_vif({
            name: this.edited_item.name,
          })
          .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
              this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"})
              return;
            }
          })
          .catch(error => {
              console.log(error);
              this.$fire({title: "Command failed", text: error, type: "warning"});
          })
          this.vifs.splice(this.edited_index, 1);
        },

        save() {
          if (this.edited_index != -1) {
            this.update();
          }
          else {
            this.save_new();
          }
        },

        on_update_completed() {
          api_client.run_post_query('/vif/show_with_name', {
            name: this.edited_item.name
          })
          .then(response => {
              Object.assign(this.vifs[this.edited_index], response.data);
          })
          .catch(error => {
              console.log(error);
          })
          this.close();
        },

        update_cb() {
            let step = this.save_steps[this.save_step_ind++];
   
            api_client.run_post_query(step.url, step.prms)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    if (this.save_step_ind == this.save_steps.length) {
                        this.on_update_completed();
                    }
                    else {
                        this.update_cb();
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        update() {
          let up_flags = [];
          let down_flags = [];

          this.old_flags.forEach(e => {
            if (!this.edited_item.flags.includes(e)) {
              down_flags.push(e);
            }
          });

          this.edited_item.flags.forEach(e => {
            if (!this.old_flags.includes(e)) {
              up_flags.push(e);
            }
          });

          if (up_flags.includes('kni') || up_flags.includes('npf_on') || 
            down_flags.includes('kni') || down_flags.includes('npf_on')) {
            this.$fire({title: "Command failed", text: 'NPF or KNI flags can not be changed', type: "warning"});
            return;
          }

          this.save_steps = [];

          if (down_flags.length != 0) {
            this.save_steps.push({
              url: '/vif/flags',
              prms: {
                action: 'down',
                name: this.edited_item.name,
                flags: down_flags.join(',')
              }
            });
          }

          if (up_flags.length != 0) {
            this.save_steps.push({
              url: '/vif/flags',
              prms: {
                action: 'up',
                name: this.edited_item.name,
                flags: up_flags.join(',')
              }
            });
          }

          if (this.save_steps.length != 0) {
            this.save_step_ind = 0;
            this.update_cb();
          }
          else {
            this.close();
          }
        },

        save_new() {
          if (this.edited_item.encapsulation === 'QinQ') {
            if (this.edited_item.svid === "") {
              this.$fire({
                title: "Incorrect SVID value",
                text: "SVID value must be defined for QinQ encapsulation",
                type: "warning"});
              return;
            }
          }

          const nat_ind = this.edited_item.flags.indexOf("NAT");
          if (nat_ind != -1) {
            this.edited_item.flags.splice(nat_ind, 1);
          }
          let new_vif = {
              name: this.edited_item.name,
              port: this.edited_item.port,
              type: this.edited_item.encapsulation.toLowerCase(),
              cvid: this.edited_item.cvid,
          }
          if (this.edited_item.flags.length != 0) {
            new_vif["flags"] = this.edited_item.flags.join(',');
          }
          if (this.edited_item.mtu != 1500) {
            new_vif["mtu"] = this.edited_item.mtu;
          }

          if (this.edited_item.encapsulation === 'QinQ') {
            new_vif["svid"] = this.edited_item.svid;
          }
          api_client.add_vif(new_vif)
            .then(response => {
              if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
              }

              api_client.sh_vif_with_name({name: this.edited_item.name})
                .then(response => {
                  if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    return;
                  }

                  this.vifs.push({
                    id: response.data.id,
                    name: response.data.name,
                    port: response.data.port,
                    svid: response.data.svid,
                    cvid: response.data.cvid,
                    encapsulation: response.data.encapsulation,
                    mac: response.data.mac,
                    flags: response.data.flags,
                    mtu: response.data.mtu,
                  })
                })
                .catch(error => {
                  console.log(error);
                  this.$fire({title: "Command failed", text: error, type: "warning"});
                })            
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            })            
          this.close();
        },
    }
  };
  </script>
  